import NftCoverImage from "../assets/project-images/NFT/nftcoverimage-min.png";
import NftFrontImage from "../assets/project-images/NFT/nftfrontimage-min.png";
import NftFirstImage from "../assets/project-images/NFT/nftfirstimage-min.png";
import NftSecondImage from "../assets/project-images/NFT/nftsecondimage-min.png";
import NftThirdImage from "../assets/project-images/NFT/nftthirdimage-min.png";

import TreactCoverImage from "../assets/project-images/treact/treact-cover.jpg";
import TreactFrontImage from "../assets/project-images/treact/treact-front.png";
import TreactFirstImage from "../assets/project-images/treact/treact-desktop.png";
import TreactSecondImage from "../assets/project-images/treact/treact-phones-1.jpg";
import TreactThirdImage from "../assets/project-images/treact/treact-phones-2.png";

import EcommerceCover from "../assets/project-images/ecommerce/ecommercecoverimage-min.png";
import EcommerceFrontImage from "../assets/project-images/ecommerce/ecommercefrontimage-min.png";
import EcommerceFirstImage from "../assets/project-images/ecommerce/ecommercefirstimage-min.png";
import EcommerceSecondImage from "../assets/project-images/ecommerce/ecommercesecondimage-min.png";
import EcommerceThirdImage from "../assets/project-images/ecommerce/ecommercethirdimage-min.png";

import NestsCoverImage from "../assets/project-images/nests/nestscoverimage-min.png";
import NestsFrontImage from "../assets/project-images/nests/nestfrontimage-min.png";
import NestsFirstImage from "../assets/project-images/nests/nestfirstimage-min.png";
import NestsSecondImage from "../assets/project-images/nests/nestsecondimage-min.png";
import NestsThirdImage from "../assets/project-images/nests/neststhirdimage-min.png";

const projectsConfig = [
  {
    title: "NFT Marketplace",
    type: "Web App",
    description:
      "An NFT marketplace that uses an API to dynamically fetch and display real-time information on individual artists and their latest NFTs. With an intuitive interface and comprehensive details, our platform provides a user-friendly experience for art enthusiasts and collectors.",
    liveLink: "https://nft.johnnym.me/",
    githubLink: "https://github.com/JohnnyM-git/nft-marketplace",
    coverImage: NftCoverImage,
    topImage: NftFrontImage,
    firstImage: NftFirstImage,
    secondImage: NftSecondImage,
    thirdImage: NftThirdImage,
  },
  // {
  //   title: "Treact",
  //   type: "Web App",
  //   description:
  //     "2Fair Work, Building & Construction needed a better faster, less labor intensive way of providing advice to people on site. Feel created a choose your own adventure style scenario based app which allows people to quickly navigate through real life scenarios in order to get workplace rights and responsibilities advice on a number of topics, instantly.",
  //   liveLink: "https://jonathan6242.github.io/treact/",
  //   githubLink: "https://jonathan6242.github.io/treact/",
  //   coverImage: TreactCoverImage,
  //   topImage: TreactFrontImage,
  //   firstImage: TreactFirstImage,
  //   secondImage: TreactSecondImage,
  //   thirdImage: TreactThirdImage,
  // },
  {
    title: "Nests Social",
    type: "Web App",
    description:
    "Nest.social is a recently launched social media platform that places a high priority on user experience. Our platform is designed with the user in mind, and we have leveraged cutting-edge technologies such as NextJS and Google Firebase to achieve this goal.",
    liveLink: "",
    githubLink: "",
    coverImage: NestsCoverImage,
    topImage: NestsFrontImage,
    firstImage: NestsFirstImage,
    secondImage: NestsSecondImage,
    thirdImage: NestsThirdImage,
  },
  {
    title: "React Ecommerce",
    type: "Web App",
    description:
      "Welcome to our online bookstore, where we provide a seamless shopping experience for book enthusiasts. Our platform uses advanced API technology to dynamically fetch real-time information on individual books, offering comprehensive details to help you make informed purchasing decisions. With an intuitive interface and user-friendly design, our platform provides a hassle-free shopping experience.",
    liveLink: "https://library.johnnym.me/",
    githubLink: "https://github.com/JohnnyM-git/ecommerce",
    coverImage: EcommerceCover,
    topImage: EcommerceFrontImage,
    firstImage: EcommerceFirstImage,
    secondImage: EcommerceSecondImage,
    thirdImage: EcommerceThirdImage,
  },
];

export default projectsConfig;
